import React from "react";
import "./FlexImage.scss";

const FlexImage = ({ images = [] }) => {
  return (
    <div className="FlexImage">
      {images.map((imgSrc, index) => (
        <img
          key={index}
          className="flexImg"
          src={imgSrc}
          alt={`flex-img-${index}`}
        />
      ))}
    </div>
  );
};

export default FlexImage;
